<script setup lang="ts">
import { faFilePdf, faLink } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VTooltip from '@shared/component/VTooltip/VTooltip.vue';
</script>

<template>
  <div class="flex flex-col items-start gap-4">
    <VTooltip label="Deze kunt u zelf invullen en versturen">
      <a class="flex items-center gap-ch" href="/net/SEPA/SEPAMachtigingTP">
        <FontAwesomeIcon :icon="faFilePdf" />

        <span>SEPA machtiging downloaden (pdf)</span>
      </a>
    </VTooltip>

    <VTooltip
      label="De machtiging wordt vervolgens automatisch verstuurd aan SUREBusiness; u ontvangt een kopie"
    >
      <a class="flex items-center gap-ch" href="/net/SEPA/SignSEPAMachtigingTP" target="_blank">
        <FontAwesomeIcon :icon="faLink" />

        <span>SEPA machtiging digitaal tekenen</span>
      </a>
    </VTooltip>
  </div>
</template>
